import React from 'react';

const Profile: React.FC = () => {
  return <>Profile Screen</>;
};

export default Profile;
